import React, { FC } from 'react';
import styled from 'styled-components';
import { ExternalSource } from 'src/actions/integrations/integrationSources';
import { SearchPanel, DebugFlowType } from './SearchPanel';

type LookupDebuggerPageProps = {
  enabledIntegrations: ExternalSource[];
  flowType: DebugFlowType;
  integrationLoadingState: any;
  onSubmit: Function;
  currentApp?: ExternalSource;
  unloadResources: Function;
  workFlowTitle: string;
};

const LookupDebuggerPageLayout: FC<LookupDebuggerPageProps> = ({
  children,
  currentApp,
  enabledIntegrations,
  flowType,
  integrationLoadingState,
  onSubmit,
  unloadResources,
  workFlowTitle,
}) => {
  return (
    <LookupDebuggerContainer data-aid="debugger-container">
      <LeftPanelContainer>
        <SearchPanel
          enabledIntegrations={enabledIntegrations}
          loadingState={integrationLoadingState}
          onSubmit={onSubmit}
          workFlowTitle={workFlowTitle}
          flowType={flowType}
          unloadResources={unloadResources}
        />
      </LeftPanelContainer>
      {currentApp ? <ResultsContainer data-aid="results-container">{children}</ResultsContainer> : null}
    </LookupDebuggerContainer>
  );
};

export default LookupDebuggerPageLayout;

const LookupDebuggerContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

const ResultsContainer = styled.div`
  height: 100%;
  overflow: auto;
  padding: 24px;
  width: 100%;
`;

const LeftPanelContainer = styled.div`
  background-color: ${p => p.theme.colors.white};
  display: flex;
  overflow-y: auto;
  min-width: 378px;
`;
